import React from 'react';
import { getRegion } from './../../../../utils/Region';
//----------------------------------------------------------
import { FadeInImage } from '../../../../components/FadeInImage';
import './style.scss';
import { showPlaceHolderorImg } from 'containers/MundialViews/utils/mundialUtils';
import { pushEvent } from 'containers/Player/utils/analytics';
import {
  events,
  Actions,
  category,
} from 'containers/MundialViews/utils/analytics';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const TeamItem = ({
  teamInfo,
  containerStyles = {},
  imageStyles = {},
  marginBottom = 0,
  actionTag,
}) => {
  const navigate = useNavigate();

  const handleTeamClick = () => {
    pushEvent(events.CARDMATCH, category.MENU, actionTag, teamInfo?.names.full);
    navigate(`/${getRegion()}/vcard/team/${teamInfo.id}`);
  };
  const { vcard_team_placeholder_img: placeholderVcard } = useSelector(
    state => state.asset,
  );

  const imgReturn = showPlaceHolderorImg(
    teamInfo?.images?.teamLogo,
    placeholderVcard,
  );
  return (
    <div
      className="team-item"
      style={{ marginBottom }}
      onClick={handleTeamClick}
    >
      <div className="team-item__img" style={containerStyles}>
        <FadeInImage
          classNames={['team-item__img__image']}
          imageAlt="mundial-team"
          imageSrc={imgReturn.placeholder ? imgReturn.placeholder : imgReturn}
          width={imageStyles.width}
          height={imageStyles.height}
          styles={imageStyles}
        />
      </div>
      <span
        className="team-item__name"
        style={{ width: containerStyles?.width }}
      >
        {teamInfo?.names.full}
      </span>
    </div>
  );
};
